import { Button } from 'primereact/button';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isIOS, isAndroid,} from 'react-device-detect';
import MapTabComponent from '../map-tab/mapTab.component';
import { getPharmacyInfo } from '../../../service/pharmacy.service';
import React from 'react';
import { goTo } from '../../../utilities/common.utilities';
import { useConnectivity } from '../../../context/connectivityContext';


type PharmaState = {
    name: string;
    address: string;
    city: string;
    telephone: string;
    email: string;
    latitude: number;
    longitude: number;
}


    export default function PharmaTabComponent() {
        const [pharma, setPharma] = useState<PharmaState>({
            name: '',
            address: '',
            city: '',
            telephone: '',
            email: '',
            latitude: 0,
            longitude: 0,
        });

        const { isOnline } = useConnectivity();

        const location = useLocation();

        // Se non sono presenti dati in location.state, reindirizzo in home al posto
        // di far andare in errore il componente
        if(!location.state) {
            goTo('/home');
        }

        const { cardData } = location.state;

        const getPharmaInfo = () => {
        
            getPharmacyInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(pharmaInfo => {
                let result: PharmaState = {
                    name: '',
                    address: '',
                    city: '',
                    telephone: '',
                    email: '',
                    latitude: 0,
                    longitude: 0,
                   }; 
                    if(pharmaInfo?.length > 0){
                        if(pharmaInfo[0].stores.length > 0){
                            result = {
                                    name: pharmaInfo[0].stores[0].name,
                                    address: pharmaInfo[0].stores[0].address.address,
                                    city: pharmaInfo[0].stores[0].address.city,
                                    telephone: pharmaInfo[0].stores[0].telephone,
                                    email: pharmaInfo[0].stores[0].email,
                                    latitude: pharmaInfo[0].stores[0].latitude,
                                    longitude: pharmaInfo[0].stores[0].longitude
                                }
                            };
                        } else { 
                       result = {
                        name: '',
                        address: '',
                        city: '',
                        telephone: '',
                        email: '',
                        latitude: 0,
                        longitude: 0,
                       };
                    }
                        setPharma(result);
            });
    }

    useEffect(() => {
        getPharmaInfo();

    }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


    const chiama = (number: string) => {
        if(isAndroid){
            window.location.href = 'tel:' + number;
        }
        else if(isIOS){
            window.location.href = 'telprompt:'+ number;
        }
    };    

    const naviga = () => {
        let query = (pharma.address +' '+ pharma.city).replace(' ','+');
        let url: string = 'https://www.google.com/maps/search/?api=1&query='+query; //example = Strada+Trasimeno+Ovest+5+Perugia (ogni spazio equivale ad un '+')
        window.open(url,'_self');
    }

    const pharmacyCard = () => (
        <>
        <div className="m-3 vh-100 card-farmacie shadow-2">
            <div className="flex flex-column">

                { (pharma.latitude || pharma.longitude) && isOnline ?
                    <MapTabComponent default={{lat: pharma.latitude, lng: pharma.longitude}}/>
                    : <></>
                }
                <div className="flex flex-column lg:flex-row justify-content-between align-items-start lg:flex-1 ml-2 mt-1">
                    <div className="flex flex-column align-items-center lg:align-items-start gap-3">
                        <div className="flex flex-column gap-1">
                            <div className="col-12 ">
                                <div className="text-xl font-bold mb-3 pharma-tab-name ">{pharma.name}</div>
                                <div className="text-700 text-lg mb-1 mt-3">
                                    <i className="pi pi-map-marker mr-1 " style={{ color: 'var(--primary-color)' }}></i>
                                    <span className="text-700 text-xl pharmaTab-text">
                                        {
                                            (pharma.address || '') +
                                            ' ' +
                                            (pharma.city || '')
                                        }
                                    </span>
                                </div>
                                <div className='flex justify-content-start flex-wrap '>
                                    <Button size='small' className='style-button-farmacie' style={{width: '120px'}} label='Naviga'
                                        onClick={() => naviga() }>
                                    </Button> 
                                </div>
                            </div>
                            
                            <div className='col-12' >
                                <div>

                                    <div className="flex flex-column justify-content-start  mb-4 text-700 text-lg " >
                                        <div className='mt-1'>
                                            <i className="pi pi-envelope" style={{ color: 'var(--primary-color)',  }}></i> 
                                            <span className="font-bold mt-1 ml-1 pharmaTab-text" style={{cursor:'pointer'}} onClick={() => window.location.href = 'mailto:'+pharma.email }>
                                                Email
                                            </span>
                                        </div>

                                        <span className='mt-1 text-700 text-xl pharmaTab-text' style={ {color: 'inherit', textDecoration: 'none'}}
                                            onClick={() => window.location.href = 'mailto:'+pharma.email }> {pharma.email}
                                        </span>  

                                    </div>
                                    <div className='flex flex-column justify-content-start mt-2 mb-4 text-700 text-lg' >
                                        <div>
                                            <i className="pi pi-phone" style={{ color: 'var(--primary-color)' }}></i>
                                            <span className="font-bold mt-1 ml-1 pharmaTab-text" style={{cursor:'pointer'}} onClick={() => chiama(pharma.telephone) }>Telefono</span>
                                        </div>
                                        <span className="text-700 text-xl mt-1 pharmaTab-text" style={ {color: 'inherit', textDecoration: 'none'}}
                                            onClick={() => chiama(pharma.telephone) }>
                                            {pharma.telephone}
                                        </span> 

                                        <div className='flex justify-content-start flex-wrap mt-4 ' >

                                            <div className='flex justify-content-center flex-wrap mr-3'>
                                                <Button size='small' className='mt-1 style-button-farmacie' style={{width: '120px'}} label='Chiamaci' 
                                                    onClick={() => chiama(pharma.telephone) }>
                                                </Button> 
                                            </div>
                                            <div className='flex justify-content-center flex-wrap '>
                                                <Button size='small' className='mt-1 style-button-farmacie' style={{width: '120px'}} label='Scrivici'
                                                    onClick={() => window.location.href = 'mailto:'+pharma.email }>
                                                </Button> 
                                            </div>    
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );

    return (
        <>
        {
            pharma?.name
            ?
            pharmacyCard()
            :
            <div className="mt-2">
                <div className="flex justify-content-center">
                    <h2 className="mb-0 mt-2">Info e Contatti</h2>
                </div>

                <div className='flex flex-column text-center text-lg mt-5'>
                    <div>I dati della farmacia non sono disponibili.</div>
                    {
                        navigator.onLine
                        ?
                        <></>
                        :
                        <div>Verifica la connessione internet.</div>
                    }
                </div>

            </div>
        }
        </>
    );

    

}